module.exports = __webpack_public_path__ + "img/business_7.cca915e0.jpg";